import { Component } from '@angular/core'

@Component({
  selector: 'app-digital-specialist',
  templateUrl: './digital-specialist-page.component.html',
  styleUrls: [`./digital-specialist-page.component.scss`],
})
export class DigitalSpecialistPageComponent {}
